import { createReducerContext } from '../../../../utils/create-reducer-context';
import { DEFAULT_PRESET, getPresetPeriod } from '../dashboard-period';
import { ACTION_TYPES, DashboardReducer, DashboardState } from './dashboard-reducer';

const initialState: DashboardState = {
    preset: DEFAULT_PRESET,
    ...getPresetPeriod('30d'),
    loading: true,
};

const { Provider: DashboardProvider, useStateContext: useDashboardState, useDispatchContext: useDashboardDispatch } =
    createReducerContext('SerDashboard', DashboardReducer, initialState);

export { DashboardProvider, useDashboardState, useDashboardDispatch, ACTION_TYPES };
